import {
  RxDashboard,
} from "react-icons/rx";
import {
  AiOutlineProduct,
} from "react-icons/ai";
import {
  TbArrowsExchange,
  TbListDetails,
  TbLogout2,
  TbPackages,
  TbTruckLoading,
} from "react-icons/tb";
import {
  FaHourglassStart,
  FaPersonCircleCheck,
  FaQuestion,
  FaRegNewspaper,
  FaUserDoctor,
  FaUsers,
} from "react-icons/fa6";
import {
  IoDocumentsOutline,
  IoPersonAddOutline,
  IoStorefrontOutline,
} from "react-icons/io5";
import {
  MdChecklist,
  MdCreditScore,
  MdDomainVerification,
  MdIncompleteCircle,
  MdOutlineAccountBalance,
  MdOutlineAssignment,
  MdOutlineDeliveryDining,
  MdOutlineHistory,
  MdOutlineMoney,
  MdOutlinePersonOff,
  MdOutlineRestaurantMenu,
  MdOutlineSwitchAccount,
  MdOutlineWarehouse,
  MdSchool,
  MdOutlineAccountCircle,
} from "react-icons/md";
import { HiOutlineSpeakerphone } from "react-icons/hi";
import { HiOutlineCommandLine } from "react-icons/hi2";
import {
  GoCrossReference,
  GoListOrdered,
  GoMoveToEnd,
  GoUnverified,
  GoVerified,
} from "react-icons/go";
import { RiCustomerService2Line, RiOrderPlayFill } from "react-icons/ri";
import { BsPersonArmsUp } from "react-icons/bs";

export const getAdminNavItems = (adminLevel: string | null, role: any[]) => {
  const items = [
    {
      title: "Dashboard",
      url: "/dashboard",
      icon: RxDashboard,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "Push notification"))) && {
      title: "Push Notification",
      url: "/dashboard/push-notification",
      icon: HiOutlineSpeakerphone,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "News update"))) && {
      title: "News Update",
      url: "/dashboard/news-update",
      icon: FaRegNewspaper,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "Web Visitors"))) && {
      title: "Web Visitors",
      url: "/dashboard/web-visitors",
      icon: MdOutlineSwitchAccount,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "Packages"))) && {
      title: "Packages",
      url: "/dashboard/packages",
      icon: TbPackages,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "Store"))) && {
      title: "Store",
      url: "/dashboard/store",
      icon: IoStorefrontOutline,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "Logistics"))) && {
      title: "Logistics",
      url: "/dashboard/logistics",
      icon: MdOutlineDeliveryDining,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "Restaurants"))) && {
      title: "Restaurants",
      url: "/dashboard/restaurants",
      icon: MdOutlineRestaurantMenu,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "Warehouse Management"))) && {
      title: "Ware House Mgt.",
      url: "/dashboard/warehouse-management",
      icon: MdOutlineWarehouse,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "Order Tracking"))) && {
      title: "Order Tracking",
      url: "/dashboard/order-tracking",
      icon: AiOutlineProduct,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "Referrals"))) && {
      title: "Referrals",
      url: "/dashboard/referrals",
      icon: GoCrossReference,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "Dietitians"))) && {
      title: "Dietitians",
      url: "/dashboard/dietitians",
      icon: FaUserDoctor,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "Vendors"))) && {
      title: "Vendors",
      url: "/dashboard/vendors",
      icon: BsPersonArmsUp,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "Staff"))) && {
      title: "Staff",
      url: "/dashboard/staff",
      icon: FaPersonCircleCheck,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "Operations"))) && {
      title: "Operations",
      url: "/dashboard/operations",
      icon: TbTruckLoading,
    },
    (adminLevel === "superadmin") && {
      title: "Assignment",
      url: "/dashboard/assignment",
      icon: MdOutlineAssignment,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "Virtual Account"))) && {
      title: "Virtual Account",
      url: "/dashboard/virtual-account",
      icon: MdOutlineAccountBalance,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "E-Verification 1"))) && {
      title: "E-Verification 1",
      url: "/dashboard/employed-verification1",
      icon: GoUnverified,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "SE-Verification 1"))) && {
      title: "SE-Verification 1",
      url: "/dashboard/self-employed-verification1",
      icon: GoVerified,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "S-Verification 1"))) && {
      title: "S-Verification 1",
      url: "/dashboard/student-verification1",
      icon: MdDomainVerification,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "Document Check"))) && {
      title: "Document Check",
      url: "/dashboard/document-check",
      icon: IoDocumentsOutline,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "Credit Score"))) && {
      title: "Credit Score",
      url: "/dashboard/credit-score",
      icon: MdCreditScore,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "Institute Upload"))) && {
      title: "Institute Upload",
      url: "/dashboard/institute-upload",
      icon: MdSchool,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "Next Pay"))) && {
      title: "Next Pay",
      url: "/dashboard/next-pay",
      icon: MdOutlineMoney,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "E-mandate"))) && {
      title: "E-mandate",
      url: "/dashboard/e-mandate",
      icon: HiOutlineCommandLine,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "Initiate Mandate"))) && {
      title: "Initiate Mandate",
      url: "/dashboard/pending-emandate",
      icon: FaHourglassStart,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "Incomplete Users"))) && {
      title: "Incomplete Users",
      url: "/dashboard/incomplete-users",
      icon: MdIncompleteCircle,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "User Details"))) && {
      title: "User Details",
      url: "/dashboard/user-details",
      icon: TbListDetails,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "Users"))) && {
      title: "Users",
      url: "/dashboard/users",
      icon: FaUsers,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "Orders"))) && {
      title: "Orders",
      url: "/dashboard/order-requests",
      icon: MdChecklist,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "State Government Orders"))) && {
      title: "State Government Orders",
      url: "/dashboard/state-government-orders",
      icon: RiOrderPlayFill,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "Order History"))) && {
      title: "Order History",
      url: "/dashboard/order-history",
      icon: GoListOrdered,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "Defaulters"))) && {
      title: "Defaulters",
      url: "/dashboard/defaulters",
      icon: MdOutlinePersonOff,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "Create Admin"))) && {
      title: "Create Admin",
      url: "/dashboard/create-admin",
      icon: IoPersonAddOutline,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "Customer Care"))) && {
      title: "Customer Care",
      url: "/dashboard/customer-care",
      icon: RiCustomerService2Line,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "FAQ"))) && {
      title: "FAQ",
      url: "/dashboard/faq",
      icon: FaQuestion,
    },
    (adminLevel === "superadmin" || (role && role.some((data: any) => data.role === "Repayment History"))) && {
      title: "Repayment History",
      url: "/dashboard/repayment-history",
      icon: MdOutlineHistory,
    },
  ];

  return items.filter(Boolean) as any[];
};

export const getSalesOfficerNavItems = () => {
  return [
    {
      title: "Dashboard",
      url: "/sales-dashboard",
      icon: RxDashboard,
    },
    {
      title: "Push Notification",
      url: "/sales-dashboard/push-notification",
      icon: HiOutlineSpeakerphone,
    },
    {
      title: "Account Management",
      url: "/sales-dashboard/account-management",
      icon: MdOutlineAccountCircle,
    },
    {
      title: "Orders",
      url: "/sales-dashboard/orders",
      icon: MdChecklist,
      subItems: [
        // {
        //   title: "Customer Orders",
        //   url: "/sales-dashboard/orders/customer-orders",
        // },
        {
          title: "Create Order",
          url: "/sales-dashboard/orders/create-order",
        },
      ],
    },
  ];
};
